/*!

=========================================================
* Argon Dashboard React - v1.2.2
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
// import Index from "views/Index";
// import Tables from "views/examples/Tables";
// import PersonalStatement from "views/pages/PersonalStatement";
// import WorkActivities from "views/pages/WorkActivities";
// import Courses from "views/pages/Courses";
// import Mcat from "views/pages/Mcat";
// import  SchoolSearch  from "views/pages/SchoolSearch";
// import MyApplication from "views/pages/MyApplication";
import Profile from "views/pages/Profile";
// import ClientDashboard from "views/pages/Dashboard/ClientDashboard";
// import McatPowerbook from "views/pages/McatPowerbook";
// import Ideas from "views/pages/Ideas";
// import Chatbot from "views/pages/Chatbot";
import PlansPage from "views/pages/PlansPage";
import Payment from "views/pages/Payment";
import Congrats from "views/pages/Congrats";
import BillingPage from "views/pages/BillingPage";
// import Community from "views/pages/Community"
// import CommunityProMembers from "views/pages/CommunityProMembers"
// import UasCommunity from "views/pages/UasCommunity"
import Support from "views/pages/Support";
import PmrReviewGuide from "views/pages/PmrReviewGuide";
// import ThankYou from "views/pages/ThankYou";
// import ScheduleTutor from "views/pages/ScheduleTutor";
// import UpgradeUas from "views/pages/UpgradeUas";
import TpcCourses from "views/pages/TpcCourses";
// import ManageCoachTutorAvailability from "views/ManagePages/ManageCoachTutorAvailability";
// import ManageTutorRequests from "views/ManagePages/ManageTutorRequests";
// import ManageApplicationHours from "views/ManagePages/ManageApplicationHours";
import ManageUsers from "views/ManagePages/ManageUsers";
// import TpcEvents from "views/pages/TpcEvents";
// import Timeline from "views/pages/Timeline";
// import PrepTalk from "./views/pages/PrepTalk";
// import CoachDashboard from "views/pages/Dashboard/CoachDashboard";
import CreateTest from "views/pages/QuestionBank/CreateTest";
import PreviousTests from "views/pages/QuestionBank/PreviousTests";
import Performance from "views/pages/QuestionBank/Performance";
import SearchQuestions from "views/pages/QuestionBank/SearchQuestions";
import FullLengthExams from "views/pages/QuestionBank/FullLengthExams";
import TakeFullLengthExam from "views/pages/QuestionBank/TakeFullLengthExam";
import FullLengthExamResults from "views/pages/QuestionBank/FullLengthExamResults";
import GroupCodes from "views/pages/GroupCodes";
import MyFeedback from "views/pages/QuestionBank/MyFeedback";
import MuscleInnervationDrills from "views/pages/QuestionBank/MuscleInnervationDrills";
import AnkiDecks from "views/pages/AnkiDecks";

var routes = [
  // {
  //   path: "/dashboard",
  //   name: "Dashboard",
  //   icon: "ni ni-tv-2 text-primary",
  //   component: ClientDashboard,
  //   layout: "/client"
  // },
  // {
  //   path: "/coach-analytics",
  //   name: "Coach Analytics",
  //   icon: "ni ni-tv-2 text-primary",
  //   component: CoachDashboard,
  //   layout: "/client"
  // },

  // {
  //   path: "/prep-talk",
  //   name: "PrepTalk",
  //   icon: "fas fa-envelope text-info",
  //   component: PrepTalk,
  //   layout: "/client"
  // },
  {
    path: "/manage-users",
    name: "Manage Users",
    icon: "fas fa-user text-info",
    component: ManageUsers,
    layout: "/client"
  },
  {
    path: "/question-bank/previous-tests",
    name: "Previous Tests",
    icon: "fas fa-history text-info",
    component: PreviousTests,
    layout: "/client"
  },
  {
    path: "/question-bank/performance",
    name: "Performance",
    icon: "fas fa-chart-line text-warning",
    component: Performance,
    layout: "/client"
  },
  {
    path: "/question-bank/search",
    name: "Search",
    icon: "fas fa-search text-primary",
    component: SearchQuestions,
    layout: "/client"
  },
  {
    path: "/question-bank/create-test",
    name: "Create Test",
    icon: "fas fa-plus-circle text-success",
    component: CreateTest,
    layout: "/client"
  },
  {
    path: "/question-bank/full-length-exams",
    name: "Full-Length Exams",
    icon: "fas fa-file-alt text-danger",
    component: FullLengthExams,
    layout: "/client"
  },
  {
    path: "/question-bank/my-feedback",
    name: "My Feedback",
    icon: "fas fa-comment-dots text-purple",
    component: MyFeedback,
    layout: "/client"
  },
  {
    path: "/question-bank/muscle-drills",
    name: "Muscle Drills",
    icon: "fas fa-brain text-info",
    component: MuscleInnervationDrills,
    layout: "/client",
    invisible: true
  },
  {
    path: "/question-bank/full-length-exam/:attemptId/results",
    name: "Exam Results",
    icon: "fas fa-chart-bar text-info",
    component: FullLengthExamResults,
    layout: "/client",
    invisible: true
  },
  {
    path: "/question-bank/full-length-exam/:attemptId",
    name: "Take Exam",
    icon: "fas fa-pencil-alt text-warning",
    component: TakeFullLengthExam,
    layout: "/client",
    invisible: true
  },
  {
    path: "/question-bank",
    name: "Question Bank",
    icon: "ni ni-books text-success",
    component: CreateTest,
    layout: "/client",
    items: [
      {
        path: "/question-bank/create-test",
        name: "Create Test",
        icon: "fas fa-plus-circle text-success",
        component: CreateTest,
        layout: "/client"
      },
      {
        path: "/question-bank/previous-tests",
        name: "Previous Tests",
        icon: "fas fa-history text-info",
        component: PreviousTests,
        layout: "/client"
      },
      {
        path: "/question-bank/performance",
        name: "Performance",
        icon: "fas fa-chart-line text-warning",
        component: Performance,
        layout: "/client"
      },
      {
        path: "/question-bank/search",
        name: "Search",
        icon: "fas fa-search text-primary",
        component: SearchQuestions,
        layout: "/client"
      },
      {
        path: "/question-bank/full-length-exams",
        name: "Full-Length Exams",
        icon: "fas fa-file-alt text-danger",
        component: FullLengthExams,
        layout: "/client"
      },
      {
        path: "/question-bank/my-feedback",
        name: "My Feedback",
        icon: "fas fa-comment-dots text-purple",
        component: MyFeedback,
        layout: "/client"
      },
      {
        path: "/question-bank/muscle-drills",
        name: "Muscle Drills",
        icon: "fas fa-brain text-info",
        component: MuscleInnervationDrills,
        layout: "/client",
        hideForSpecialties: ['pain', 'sports']
      }
    ]
  },
  {
    path: "/video-courses",
    name: "Video Courses",
    icon: "fas fa-video text-primary",
    component: TpcCourses,
    layout: "/client"
  },
  // {
  //   path: "/community",
  //   name: "Community",
  //   icon: "fas fa-users text-warning",
  //   component: Community,
  //   layout: "/client",
  //   items:[
  //     {
  //       path: "/community-free-members",
  //       name: "Open Community",
  //       icon: "fas fa-users text-warning",
  //       component: Community,
  //       layout: "/client"
  //     },
  //
  //     // {
  //     //   path: "/community-pro-members",
  //     //   name: "Pro Members",
  //     //   icon: "fas fa-user-tie text-green",
  //     //   component: CommunityProMembers,
  //     //   layout: "/client"
  //     // },
  //
  //     {
  //       path: "/community-uas",
  //       name: "Ultimate Advising Students",
  //       icon: "fas fa-user-shield text-info",
  //       component: Community,
  //       layout: "/client"
  //     },
  //   ]
  // },
  // {
  //     path: "/community-free-members",
  //     name: "Open Community",
  //     icon: "fas fa-users text-warning",
  //     component: Community,
  //     layout: "/client"
  //   },
  // {
  //   path: "/community-pro-members",
  //   name: "Pro Members",
  //   icon: "fas fa-user-tie text-green",
  //   component: CommunityProMembers,
  //   layout: "/client"
  // },
  // {
  //   path: "/community-uas",
  //   name: "Ultimate Advising Students",
  //   icon: "fas fa-user-shield text-info",
  //   component: UasCommunity,
  //   layout: "/client"
  // },
  // {
  //   path: "/manage-coach-tutor-availability",
  //   name: "Manage Coach Tutor Availability",
  //   icon: "fas fa-calendar-alt text-pink",
  //   component: ManageCoachTutorAvailability,
  //   layout: "/client"
  // },
  // {
  //   path: "/manage-tutor-requests",
  //   name: "Manage Tutor Requests",
  //   icon: "fas fa-calendar-alt text-yellow",
  //   component: ManageTutorRequests,
  //   layout: "/client"
  // },
  // {
  //   path: "/classes",
  //   name: "Log Classes",
  //   icon: "ni ni-books text-orange",
  //   component: Courses,
  //   layout: "/client"
  // },
  // {
  //   path: "/work-activities",
  //   name: "Work/Activities",
  //   icon: "ni ni-planet text-blue",
  //   component: WorkActivities,
  //   layout: "/client"
  // },
  // {
  //   path: "/mcat",
  //   name: "MCAT",
  //   icon: "ni ni-books text-danger",
  //   component: Mcat,
  //   layout: "/client"
  // },
  // {
  //   path: "/school-search",
  //   name: "School Search",
  //   icon: "ni ni-building text-green ",
  //   component: SchoolSearch,
  //   layout: "/client"
  // },

  // {
  //   path: "/personal-statement",
  //   name: "Personal Statement",
  //   icon: "ni ni-book-bookmark text-teal",
  //   component: PersonalStatement,
  //   layout: "/client"
  // },
  // {
  //   path: "/maps",
  //   name: "Maps",
  //   icon: "ni ni-pin-3 text-orange",
  //   component: Maps,
  //   layout: "/client"
  // },
//   {
//     path: "/user-profile",
//     name: "User Profile",
//     icon: "ni ni-single-02 text-yellow",
//     component: Profile,
//     layout: "/client"
//   },


  // {
  //   path: "/my-application",
  //   name: "My Application",
  //   icon: "ni ni-bullet-list-67 text-info",
  //   component: MyApplication,
  //   layout: "/client"
  // },

//   {
//     path: "/login",
//     name: "Login",
//     icon: "ni ni-key-25 text-info",
//     component: Login,
//     layout: "/auth"
//   },
  // {
  //   path: "/mcat-powerbook",
  //   name: "MCAT Powerbook",
  //   icon: "ni ni-book-bookmark text-red",
  //   component: McatPowerbook,
  //   layout: "/client"
  // },

  // {
  //   path: "/tpc-events",
  //   name: "TPC Events",
  //   icon: "ni ni-calendar-grid-58 text-warning",
  //   component: TpcEvents,
  //   layout: "/client"
  // },

  // {
  //   path: "/ideas",
  //   name: "Ideas",
  //   icon: "ni ni-bulb-61 text-yellow",
  //   component: Ideas,
  //   layout: "/client"
  // },
  // {
  //   path: "/chatbot",
  //   name: "Chatbot",
  //   icon: "fas fa-comment text-info",
  //   component: Chatbot,
  //   layout: "/client"
  // },


  {
    path: "/anki-decks",
    name: "Anki Decks",
    icon: "fas fa-layer-group text-info",
    component: AnkiDecks,
    layout: "/client"
  },
  {
    path: "/pmr-review-guide",
    name: "PM&R Review Guide",
    icon: "fas fa-book-medical text-info",
    component: PmrReviewGuide,
    layout: "/client",
    specialties: ['pmr']
  },
  {
    path: "/group-codes",
    name: "Group Codes",
    icon: "fas fa-ticket-alt text-teal",
    component: GroupCodes,
    layout: "/client",
    coordinatorOnly: true
  },
  {
    path: "/plans",
    name: "Plans",
    icon: "ni ni-credit-card text-green",
    component: PlansPage,
    layout: "/client"
  },
  {
    path: "/billing",
    name: "Billing",
    icon: "fas fa-credit-card text-info",
    component: BillingPage,
    layout: "/client",
    invisible: true
  },
  {
    path: "/payment",
    name: "Payment",
    icon: "ni ni-credit-card text-primary",
    component: Payment,
    layout: "/client",
    invisible: true
  },
  {
    path: "/congrats",
    name: "Congrats",
    icon: "ni ni-check-bold text-success",
    component: Congrats,
    layout: "/client",
    invisible: true
  },


  {
    path: "/my-profile",
    name: "My Profile",
    icon: "ni ni-circle-08 text-pink",
    component: Profile,
    layout: "/client"
  },
  {
    path: "/report-issue",
    name: "Report Issues",
    icon: "fas fa-bug text-danger",
    component: Support,
    layout: "/client"
  },
  // {
  //   path: "/congrats-monthly",
  //   name: "Thank You Monthly",
  //   icon: "ni ni-circle-08 text-pink",
  //   component: ThankYou,
  //   layout: "/client"
  // },
  // {
  //   path: "/congrats-yearly",
  //   name: "Thank You Yearly",
  //   icon: "ni ni-circle-08 text-pink",
  //   component: ThankYou,
  //   layout: "/client"
  // },
  // {
  //   path: "/congrats-lifetime",
  //   name: "Thank You Lifetime",
  //   icon: "ni ni-circle-08 text-pink",
  //   component: ThankYou,
  //   layout: "/client"
  // },
  // {
  //   path: "/congrats-lifetime",
  //   name: "Thank You Lifetime",
  //   icon: "ni ni-circle-08 text-pink",
  //   component: ThankYou,
  //   layout: "/client"
  // },
  // {
  //   path: "/schedule-tutor",
  //   name: "Schedule Tutor",
  //   icon: "fas fa-calendar-alt text-pink",
  //   component: ScheduleTutor,
  //   layout: "/client"
  // },
  // {
  //   path: "/upgrade-uas",
  //   name: "Upgrade Uas",
  //   icon: "ni ni-circle-08 text-pink",
  //   component: UpgradeUas,
  //   layout: "/client"
  // },
  // {
  //   path: "/timeline",
  //   name: "Timeline",
  //   icon: "fas fa-stream text-danger",
  //   component: Timeline,
  //   layout: "/client"
  // },



];
export default routes;
